@if (!chatInfo?.type) {
  <nimbus-spinner [small]="false"></nimbus-spinner>
} @else {
  <div class="chat-container">
    @let messages = messages$ | async;
    <div class="chat-content">
      <nimbus-card>
        <div class="nimbus-card-title">
          <div class="chat-title">
            <i [nimbusIcon]="ICONS.COMMENT_ALT_LIGHT" [iconWeight]="IconWeight.Light"></i>
            <h3 class="title">{{ ChatTitleTranslationMapper[chatInfo.type] | translate }}</h3>
          </div>
        </div>

        <nimbus-card-controls>
          @if (copyText$ | async; as copyText) {
            <button [nimbusCopyClipboard]="copyText" nimbusPrimaryNoBorderButton class="copy-all">
              <i [iconWeight]="IconWeight.Regular" [nimbusIcon]="ICONS.COPY"></i>
              <span>{{ TranslationKeys.GeneralCopyAll | translate }}</span>
            </button>
          }
        </nimbus-card-controls>

        <nimbus-card-body class="flex-container flex-align-center">
          @if (loading$ | async) {
            <div class="loading-messages flex-container flex-align-center flex-column">
              <i [nimbusIcon]="ICONS.SPINNER" [iconWeight]="IconWeight.Regular" class="loading-spinner"></i>
              <span class="loading-text">{{ TranslationKeys.ChatWidgetLoadingMessages | translate }}</span>
            </div>
          } @else {
            <nimbus-chat-widget
              [messages]="messages"
              [chatType]="chatInfo.type"
              [taskState]="chatInfo.taskState"
              [saveDraftApiUrl]="saveDraftApiUrl"
              [conversationId]="chatInfo.conversationId"
              [enableDraft]="true"
              [unparkDisabled]="unparkDisabled"
              [unparkTooltip]="unparkTooltip"
              [isMediaHandlingEnabled]="isMediaHandlingEnabled$ | async"
              [mediaPolicy]="mediaPolicy$ | async"
              (copyTextInitialized)="onCopyTextInitialized($event)"
              (messageSent)="sendMessage($event)"
              (attachmentsSent)="sendAttachments($event)"
              (voiceMessageSent)="sendVoiceMessage($event)"
              (loadPrevMessagesRequested)="onLoadPrevMessagesRequested()"
              (unparkRequested)="unparkRequested.emit()"
            ></nimbus-chat-widget>
          }
        </nimbus-card-body>
      </nimbus-card>
    </div>
  </div>
}
